import styled from '@emotion/styled'
import { WebLink } from '@news-mono/web-common'

export const StyledSummerOfCricketPromoCard = styled.div({
    display: 'block',
    alignSelf: 'center',
})

export const StyledSummerOfCricketLink = styled(WebLink)(() => ({
    display: 'block',
}))

export const StyledPromoImg = styled.img({
    display: 'block',
    width: 'auto',
    height: 270,
})
